import { render } from "./templates/instrument-page.html?vue&type=template&id=df804616"
import script from "./InstrumentPage.vue?vue&type=script&lang=js"
export * from "./InstrumentPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__